/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'sarsaparilla';
import { GET_DISTRICT_MAP } from '../../constants';

export default class OlympicDistrictPicker extends React.PureComponent {
    static propTypes = {
        maxSelectionsNum: PropTypes.number,
        selectedDistricts: PropTypes.array,
        handleDistrictFilterClick: PropTypes.func.isRequired,
        permitId: PropTypes.string,
    };

    static defaultProps = {
        maxSelectionsNum: 6,
        selectedDistricts: [],
    };

    render() {
        const {
            permitId,
            selectedDistricts,
            maxSelectionsNum,
            handleDistrictFilterClick,
        } = this.props;
        const districts = GET_DISTRICT_MAP(permitId);
        return (
            <div className="olympic-filter-section">
                <p>Select a Starting Area:</p>
                {districts.map((district) => {
                    const isSelected = selectedDistricts.includes(district);
                    const numSelected = selectedDistricts.length;
                    const isDisabled = !isSelected && numSelected >= maxSelectionsNum;

                    return (
                        <Button
                            className="olympic-filter-button"
                            key={district}
                            name={district}
                            aria-pressed={isSelected}
                            isDisabled={isDisabled}
                            onClick={() => handleDistrictFilterClick(district)}
                        >
                            {district}
                        </Button>
                    );
                })}
            </div>
        );
    }
}
